import { keyframes } from "styled-components";

export const SlideIn = keyframes`
  0% {
    transform: translateY(-600px) rotateX(-30deg) scale(0);
    transform-origin: 50% 100%;
    opacity: 0;
    visibility: none;
  }
  100% {
    transform: translateY(0) rotateX(0) scale(1);
    transform-origin: 50% 1400px;
    opacity: 1;
    visibility: show;
    pointer-events: all;
  }
`
export const SlideBottom = keyframes`
0% {
    opacity: 0;
    visibility: none;
    transform: translateY(-100px);
  }
  100% {
    opacity: 1;
    visibility: show;
    transform: translateY(10px);
    pointer-events: all;
  }
`

export const SlideOut = keyframes`
  0% {
    transform: translateY(0) rotateX(0) scale(1);
    transform-origin: 50% 1400px;
    opacity: 1;
  }
  100% {
    transform: translateY(-600px) rotateX(-30deg) scale(0);
    transform-origin: 50% 100%;
    opacity: 0;
  }
`;

export const SlideTop = keyframes`
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-100px);
  }
`